// https://github.com/goshippo/authz/blob/main/doc/openapi.yaml
type EntitlementToken = 'custom_branding' | 'shippo_staff' | 'support_type' | 'user_seats';

type JSONQuantityEntitlement = {
  entitlement_type: 'quantity';
  is_unlimited: boolean;
  quantity: number;
  token: EntitlementToken;
};

type JSONSwitchEntitlement = {
  entitlement_type: 'switch';
  token: EntitlementToken;
};

type JSONCustomEntitlement = {
  entitlement_type: 'custom';
  token: EntitlementToken;
  value: string;
};

type JSONEntitlement = JSONCustomEntitlement | JSONQuantityEntitlement | JSONSwitchEntitlement;

export type JSONEntitlements = JSONEntitlement[];

export type QuantityEntitlement = {
  entitlementType: 'quantity';
  isUnlimited: boolean;
  quantity: number;
  token: EntitlementToken;
};

type SwitchEntitlement = {
  entitlementType: 'switch';
  token: EntitlementToken;
};

export type CustomEntitlement = {
  entitlementType: 'custom';
  token: EntitlementToken;
  value: string;
};

type Entitlement = CustomEntitlement | QuantityEntitlement | SwitchEntitlement;

export type Entitlements = Entitlement[];

export const fromJSON = (json: JSONEntitlements): Entitlements =>
  json.map((entitlement) => {
    switch (entitlement.entitlement_type) {
      case 'quantity':
        return {
          entitlementType: 'quantity',
          isUnlimited: entitlement.is_unlimited,
          quantity: entitlement.quantity,
          token: entitlement.token,
        };
      case 'switch':
        return {
          entitlementType: 'switch',
          token: entitlement.token,
        };
      case 'custom':
        return {
          entitlementType: 'custom',
          token: entitlement.token,
          value: entitlement.value,
        };
    }
  });
